import { Link, NavLink } from 'react-router-dom'
import useFetchMenu from 'Common/FetchAllMenu'
import { SidebarSkeleton } from './SidebarSkeleton '

const HotelTabSidebar = ({ iconColor }) => {
    const { menu: hotelMenu, loading: hotelLoading } = useFetchMenu('hotel');

    if (hotelLoading) {
        return <SidebarSkeleton iconColor={iconColor} />
    }

    console.log("hotelMenu", hotelMenu)

    const DefaultIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" className="svg-stroke" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 8m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
            <path d="M8 11a5 5 0 1 0 3.998 1.997" />
            <path d="M12.002 19.003a5 5 0 1 0 3.998 -8.003" />
        </svg>

    );

    return (
        <>
            <h6 className="fl-title title-font ps-2 small Taxt-uppercase Taxt-muted" style={{ "--dynamic-color": "var(--theme-color1)" }}>Universal</h6>
            <ul className={`list-unstyled mb-4 menu-list ${iconColor}`}>
                <li>
                    <NavLink to="/index" aria-label="Hotel Dashboard">
                        <svg className="svg-stroke" xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M5 12l-2 0l9 -9l9 9l-2 0"></path>
                            <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
                            <path d="M10 12h4v4h-4z"></path>
                        </svg>
                        <span className="mx-3">Dashboard</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/room-status" aria-label="Hotel Dashboard">
                        <svg
                            className="svg-stroke"
                            width="24"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" ></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round">
                            </g><g id="SVGRepo_iconCarrier">
                                <path opacity="0.4" d="M6.87988 18.1501V16.0801" strokeLinecap="round">
                                </path> <path opacity="0.4" d="M12 18.1498V14.0098" strokeLinecap="round"></path>
                                <path opacity="0.4" d="M17.1201 18.1502V11.9302" strokeLinecap="round"></path>
                                <g opacity="0.4"> <path d="M17.1199 5.84961L16.6599 6.38961C14.1099 9.36961 10.6899 11.4796 6.87988 12.4296" strokeLinecap="round"></path>
                                    <path d="M14.1904 5.84961H17.1204V8.76961" strokeLinecap="round" strokeLinejoin="round"></path>
                                </g>
                                <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" strokeLinecap="round" strokeLinejoin="round"></path>
                            </g></svg>
                        <span className="mx-3">Room Status</span>
                    </NavLink>
                </li>
                {hotelMenu?.map((parent) => {
                    const collapseId = `menu-${parent.menu_id}`;

                    if (parent.menu_id === 45) return null

                    return (
                        <li key={parent.menu_id}>
                            {/* Parent menu (collapse toggle) */}
                            <Link
                                to={`#${collapseId}`}
                                data-bs-toggle="collapse"
                                aria-expanded="false"
                                className="dropdown-toggle d-flex align-items-center"
                                aria-label={parent.menu_title}
                            >
                                {/* Optional icon */}
                                {parent.icon ? (
                                    <span
                                        className="svg-stroke"
                                        dangerouslySetInnerHTML={{ __html: parent.icon }}
                                    />
                                ) : (
                                    <DefaultIcon />
                                )}

                                <span className="mx-3 text-capitalize">
                                    {parent.menu_title}
                                </span>
                            </Link>

                            {/* Child menu */}
                            {parent.children && parent.children.length > 0 && (
                                <ul
                                    className="collapse list-unstyled"
                                    id={collapseId}
                                >
                                    {parent.children.map((child) => (
                                        <li key={child.menu_id}>
                                            <NavLink
                                                to={`/${child.page_url}`}
                                                className="text-capitalize"
                                                aria-label={child.menu_title}
                                            >
                                                {child.menu_title}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    );
                })}

                {/* <li className="py-2 mt-2">
                        <h6 className="fl-title title-font ps-2 small Taxt-uppercase Taxt-muted" style={{ "--dynamic-color": "var(--theme-color1)" }}>Reports</h6>
                        <ul className="list-unstyled">
                            <li><NavLink to="/booking-report" aria-label="Booking Reports">Booking Reports</NavLink></li>
                            <li><NavLink to="/purchase-report" aria-label="Purchase Report">Purchase Reports</NavLink></li>
                            <li><NavLink to="/stock-report" aria-label="Stock Report">Stock Reports</NavLink></li>
                        </ul>
                    </li> */}
            </ul>
        </>

    )
}

export default HotelTabSidebar